export function buildQueryParams(filters) {
  const params = new URLSearchParams()

  Object.entries(filters).forEach(([key, field]) => {
    const value = (field !== null && typeof field === 'object' && !Array.isArray(field) && 'value' in field)
      ? field.value
      : field

    if (
      value === undefined ||
      value === null ||
      value === '' ||
      (Array.isArray(value) && value.length === 0)
    ) {
      return
    }

    if (Array.isArray(value)) {
      value.forEach((currentValue) => {
        params.append(key, String(currentValue))
      })

      return
    }

    params.append(key, String(value))
  })

  return params.toString()
}
